import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=be7b6b1a&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=be7b6b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7b6b1a",
  null
  
)

export default component.exports